import "./App.css";
import * as React from "react";
import {connect} from "react-redux";
import Footer from "./components/footer/Footer";
import {routes} from "./routing/Routes";
import {ILanguageTokens} from "./localization/LanguageTokens";
import {RootState} from "./redux/store";

interface IProps {
    languageTokens: ILanguageTokens
}

function AppFooter({languageTokens}: IProps) {
    return (
        <Footer footerElements={[
            {
                name: languageTokens.LegalNotice,
                link: routes.legalNotice,
            },
            {
                name: languageTokens.Contact,
                link: routes.contact,
            },
        ]}/>
    );
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(AppFooter);
